<template>
  <v-container>
    <v-container fluid class="pa-0 ma-0">
      <v-img max-height="25vh" :src="event.header" />
    </v-container>
    <v-container class="pa-6 pt-10" fluid>
      <v-row>
        <v-col cols="12" class="col-md-6">
          <h1>{{ $t("About the Games") }}</h1>
        </v-col>
        <v-col cols="12" class="col-md-6 text-right">
          <p class="pl-4 ma-0">{{ event.name }}</p>
          <p class="pl-4 ma-0">{{ event.dates }}</p>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn @click="switchMode" v-if="this.readOnly == false">
            {{ $t("Edit") }}
          </v-btn>
          <v-btn @click="switchMode" v-else>
            {{ $t("Done Editing") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="services-list">
      <v-row dense>
        <!-- manage teams -->
        <v-col class="col-sm-12 col-md-12">
          <v-card class="pa-0" flat>
            <v-card-text if="Object.keys(this.event.about).length != 0">
              <editor
                :readOnly="this.readOnly"
                v-on:update="update"
                :data="this.event.about"
                ref="editor"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-end"
          v-if="this.readOnly == true"
        >
          <v-col class="text-right">
            <v-btn color="green lighten-2" text @click="saveGame">
              {{ $t("Save") }}
            </v-btn>
            <v-btn color="red lighten-2" text @click="reset">
              {{ $t("Cancel") }}
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);

import editor from "@/components/editor.vue";
import gameProvider from "@/modules/Games/data/games";

export default {
  name: "GameAbout",
  route: {
    path: "/games/about/:id",
    name: "About Game",
  },
  data: () => ({
    event: {
      name: "",
      dates: "",
      header: "",
      about: null,
    },
    aboutEdited: null,
    readOnly: true,
  }),
  components: {
    editor,
  },
  beforeMount() {
    this.getEvents();
  },
  methods: {
    switchMode() {
      this.readOnly = !this.readOnly;
    },
    async saveGame() {
      let savedData = await this.$refs.editor.childSave();
      this.event.about = savedData;
      let self = this;
      gameProvider
        .editSingleGame(this.$route.params.id, this.event)
        .then(function (event) {});
    },
    reset() {
      this.$router.push(`/games/about/${this.event.id}`);
    },
    async update(value) {
      this.aboutEdited = value;
    },
    async getEvents() {
      let self = this;
      gameProvider.getEvent(this.$route.params.id).then(function (event) {
        if (!("about" in event)) {
          event.about = {
            time: 1550476186479,
            blocks: [
              {
                type: "header",
                data: {
                  text: "Click to start editing",
                  level: 1,
                },
              },
            ],
            version: "2.8.1",
          };
        }

        self.event = event;
      });
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
a {
  text-decoration-line: none;
}
.services-list {
  .v-card {
    min-height: 250px;
  }
}
</style>
